import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SEO from "@/components/site/SEO";
import { faqItems } from "@/data/faq";
import { breadcrumbSchema } from "@/data/site";

export default function FAQPage() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map((f) => ({
      "@type": "Question",
      "name": f.q,
      "acceptedAnswer": { "@type": "Answer", "text": f.a },
    })),
  };

  return (
    <div className="bg-white text-brand-black">
      <SEO
        title="FAQ · Real Estate Listing Support Questions"
        description="Answers to common questions about LotWise Home, including pricing, MLS-ready materials, property photography, monthly plans, service areas, and payment terms."
        path="/faq"
        schema={[faqSchema, breadcrumbSchema([{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }])]}
      />
      <section className="bg-brand-black text-white">
        <div className="mx-auto max-w-[1360px] px-5 md:px-10 py-24 md:py-32">
          <div className="eyebrow text-white/60">FAQ</div>
          <h1 className="mt-4 text-[40px] md:text-7xl font-bold tracking-[-0.02em] leading-[1.0] max-w-4xl">
            Straight answers, on the record.
          </h1>
          <p className="mt-8 max-w-2xl text-[16px] leading-relaxed text-white/70">
            Real objections and honest answers. If something is missing, the fastest way to get a
            direct response is to send us the specifics.
          </p>
        </div>
      </section>

      <section className="bg-white">
        <div className="mx-auto max-w-[1000px] px-5 md:px-10 py-16 md:py-24">
          <Accordion type="single" collapsible data-testid="faq-accordion">
            {faqItems.map((f, i) => (
              <AccordionItem key={f.q} value={`f-${i}`} className="border-b border-brand-gray/25">
                <AccordionTrigger className="text-left text-[16px] md:text-[17px] font-medium py-6 hover:no-underline">
                  <span className="pr-6">{f.q}</span>
                </AccordionTrigger>
                <AccordionContent className="text-[15px] leading-relaxed text-brand-gray pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      <section className="bg-brand-black text-white">
        <div className="mx-auto max-w-[1360px] px-5 md:px-10 py-20 md:py-28 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <h3 className="text-2xl md:text-4xl font-bold tracking-tight max-w-2xl">Still deciding? Send us the details.</h3>
          <Link to="/contact" className="inline-flex items-center gap-2 bg-white text-brand-black px-6 py-3.5 text-[13px] font-bold">
            Request Listing Support <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
